var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12539 -18577)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-12539 18577)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12533.736 18582.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3046.115-864.992l1.29-.448a15.734,15.734,0,0,1,5.252-1.124,13.417,13.417,0,0,1,4.679.847,10.456,10.456,0,0,0,8.145-.194,11.108,11.108,0,0,1,1.7-.614,1.614,1.614,0,0,1,2.055,1.617q0,7.318.006,14.636a1.59,1.59,0,0,1-1.068,1.659,14.416,14.416,0,0,1-5.735,1.138,22.179,22.179,0,0,1-5.3-.947,14.976,14.976,0,0,0-6.087-.549,18.309,18.309,0,0,0-4.652,1.372c-.3.122-.326.334-.326.6q.007,2.329,0,4.657a1.093,1.093,0,0,1-.93,1.209,1.127,1.127,0,0,1-1.368-1.089c-.007-.088,0-.177,0-.266q0-11.354,0-22.708a1.168,1.168,0,0,1,.748-1.274,1.129,1.129,0,0,1,1.55.962C3046.083-865.366,3046.094-865.224,3046.115-864.992Zm20.821,7.781v-.976q0-2.617,0-5.234c0-.478-.072-.517-.521-.346-.316.121-.635.235-.955.346a12.844,12.844,0,0,1-9.045-.158,9.693,9.693,0,0,0-5.355-.471,26.627,26.627,0,0,0-4.464,1.405.7.7,0,0,0-.527.776c.015,3.711.009,7.421.009,11.132,0,.767.005.771.731.488a16.7,16.7,0,0,1,9.916-.668c1.236.276,2.459.616,3.7.872a11.646,11.646,0,0,0,5.9-.345.739.739,0,0,0,.627-.835C3066.915-853.219,3066.935-855.215,3066.936-857.211Z",
    transform: "translate(-3043.77 866.582)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWl);
export default __webpack_public_path__ + "static/media/icon-wl.c8534f56.svg";
export { ForwardRef as ReactComponent };